<template>
  <section class="specials">
    <div class="specials__head">
      <h1 class="specials__title">特集・キャンペーン一覧</h1>
    </div>
    <SpecialsPageBody />
    <div class="specials__footer">
      <div class="specials__back-to-root">
        <a
          href="/"
          class="specials__back-to-root__link tl-link-chevron-back--left"
        >
          gifteeトップへ戻る
        </a>
      </div>
      <div class="specials__back-to-top">
        <span class="text-link-to-top" @click.self="onClickLinkToTop">
          ページトップへ ▲
        </span>
      </div>
    </div>
  </section>
</template>
<script>
import SpecialsPageBody from './SpecialsPageBody.vue'

export default {
  components: { SpecialsPageBody },
  methods: {
    onClickLinkToTop() {
      this.scrollToTop()
    },
    scrollToTop() {
      window.scrollTo({ top, behavior: 'smooth' })
    }
  }
}
</script>
<style lang="scss" scoped>
.specials {
  overflow: hidden;

  &__head {
    padding: 24px 16px;
    margin: 0 0 16px 0;
    background-color: $white;
  }

  &__title {
    @extend %title;

    max-width: 840px;
    text-align: left;
    margin: auto;
  }

  &__back-to-root {
    padding: 24px 0 56px 0;
    margin: auto;
    font-size: 1.6rem;
    line-height: 1.6;
    text-align: left;
    width: 840px;

    &__link {
      color: $link;
      background-color: transparent;
    }
  }

  &__back-to-top {
    margin: auto;
    padding: 16px 0;
    background-color: $gray-2;

    .text-link-to-top {
      display: inline;
    }
  }
}
</style>
